import LocalStorageOperation from '@naruto/naruto-models/src/core/localStorageOperator';
import { AuthKey, AuthType } from '@naruto/naruto-api/src/tools/Header';
import { ThunkAction, Models, MiddleWare, TokenStoreName } from './types';

export const readLocalTokenAndSave =
  (): ThunkAction<Promise<string>, Models, MiddleWare, { type: string }> =>
  async (dispatch, getState, { api, env }): Promise<string> => {
    const localStorageReader = new LocalStorageOperation<TokenStoreName>({
      savedStorageItemName: env.config.JwtTokenLocalName
    });
    const localToken = localStorageReader.readStorage();
    if (localToken && 'token' in localToken) {
      api.baseHeader.updateToken(AuthKey.AUTHORIZATION, AuthType.BEARER, localToken.token);
      return localToken.token;
    }
    localStorageReader.deleteStorage();
    return '';
  };
export const saveLocalToken =
  (token: string): ThunkAction<Promise<void>, Models, MiddleWare, { type: string }> =>
  async (dispatch, getState, { api, env }): Promise<void> => {
    const localStorageReader = new LocalStorageOperation<TokenStoreName>({
      savedStorageItemName: env.config.JwtTokenLocalName
    });
    localStorageReader.updateStorage({ token });
    api.baseHeader.updateToken(AuthKey.AUTHORIZATION, AuthType.BEARER, token);
  };
export const removeLocalToken =
  (): ThunkAction<Promise<void>, Models, MiddleWare, { type: string }> =>
  async (dispatch, getState, { api, env }): Promise<void> => {
    const localStorageReader = new LocalStorageOperation<TokenStoreName>({
      savedStorageItemName: env.config.JwtTokenLocalName
    });
    localStorageReader.deleteStorage();
    api.baseHeader.removeToken(AuthKey.AUTHORIZATION);
  };
